export type TradeTabId = 'hvac' | 'plumbing' | 'electrical';

export const TRADE_TAB_ORDER: readonly TradeTabId[] = ['hvac', 'plumbing', 'electrical'];

// Trade ids (id-parity with timesheet_department): jobs match on eventTradeId, techs on departmentCode.
// Full trade list lives in utils/eventTrade.ts (TRADE_IDS).
export const TRADE_TAB_DEPARTMENT_CODE: Record<TradeTabId, number> = {
  hvac: 20,
  plumbing: 34,
  electrical: 15,
};

export const TRADE_TAB_LABEL: Record<TradeTabId, string> = {
  hvac: 'HVAC',
  plumbing: 'Plumbing',
  electrical: 'Electrical',
};
